export enum DisputeTypesEnum {
  DisputeResolutionProcess = 'DRP',
  OverchargeClaims = 'OCC',
  InspectionAppeals = 'WNI',
  MassReRate = 'MRRA',
}
